import React from 'react';

export const InfoBlock = (props) => {
    return (
        <div style={{ borderColor: props.color }} className="signature-block">
            <div className="container-fluid">
                <label>{props.title}</label>
                <div style={{ maxWidth: "207px", margin: "auto" }}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/InfoBlock.js